export class SoulDataModel {
  userId: string;
  email: string;
  fullName: string;
  role: string[];
  currentCompany: CompanyModel;
  currentStore: StoreModel;
  paths: string[];
  rolePaths: Record<string, string[]>;

  constructor(data: any) {
    this.userId = data.userId;
    this.fullName = data.fullName;
    this.role = data.role;
    this.email = data.email;
    this.currentCompany = new CompanyModel(data.currentCompany);
    this.currentStore = new StoreModel(data.currentStore);
    this.paths = data.paths;
    this.rolePaths = data.rolePaths;
  }
}

export class CompanyModel {
  companyCode: string;
  companyName: string;
  companyDescription: string;
  imageUrl: string;
  identification: string;
  address: string;
  phoneNumber: string;

  constructor(data: any) {
    this.companyCode = data.companyCode;
    this.companyName = data.companyName;
    this.companyDescription = data.companyDescription ?? null;
    this.imageUrl = data.imageUrl ?? null;
    this.identification = data.identification ?? null;
    this.address = data.address ?? null;
    this.phoneNumber = data.phoneNumber ?? null;
  }
}

export class StoreModel {
  storeCode: string;
  storeName: string;
  companyCode: string;

  constructor(data: any) {
    this.storeCode = data.storeCode;
    this.storeName = data.storeName;
    this.companyCode = data.companyCode;
  }
}

export class UpdateSoulInfoPayload {
  payload: SoulDataModel;

  constructor(payload: SoulDataModel) {
    this.payload = payload;
  }
}
